export function buildFinanceExceptionBreakdown(financeSummary = {}) {
    const buckets = [
        {
            key: 'pending',
            label: 'Pending',
            count: Number(financeSummary.pending_transaction_count || 0),
            total: Number(financeSummary.pending_transaction_total || 0),
        },
        {
            key: 'failed',
            label: 'Failed',
            count: Number(financeSummary.failed_processing_transaction_count || 0),
            total: Number(financeSummary.failed_processing_transaction_total || 0),
        },
        {
            key: 'declined',
            label: 'Declined',
            count: Number(financeSummary.declined_transaction_count || 0),
            total: Number(financeSummary.declined_transaction_total || 0),
        },
        {
            key: 'canceled',
            label: 'Voided / canceled',
            count: Number(financeSummary.canceled_transaction_count || 0),
            total: Number(financeSummary.canceled_transaction_total || 0),
        },
    ];

    return buckets.filter((bucket) => bucket.count || bucket.total);
}

export function getFinancePaymentExceptionCount(financeSummary = {}) {
    return buildFinanceExceptionBreakdown(financeSummary)
        .reduce((total, bucket) => total + bucket.count, 0);
}

export function getRecentNetCapturedTotal(financeSummary = {}) {
    return Number(financeSummary.recent_approved_capture_total || 0) - Number(financeSummary.recent_refund_total || 0);
}
